import React from 'react';
import ToDo from "./ToDo";
import './Todo.css';

const ToDoList = ({toDoList, handleToggle, handleFilter}) => {
  return (
    <div>
      {toDoList.map(todo => {
               return (
                   <ToDo todo={todo} handleToggle={handleToggle} handleFilter={handleFilter}/>
               )
           })}
      <button className='common2' style={{margin: '20px'}} onClick={handleFilter}>Clear Completed</button>

    </div>
  )
}

export default ToDoList;
